jQuery(document).ready(function(jQuery){
    /*
  	$('.dropdown-toggle').dropdown();
	var btnlg1 = $('span.btn-lang1');
    var btnlg2 = $('span.btn-lang2');
    var btnActive = {
        backgroundColor : '#F1F1F1',
        color : '#000000'
    }
    var btnInactive = {
        backgroundColor : '#000000',
        color : '#FFFFFF'
    }
  
    btnlg1.css(btnActive);
  
    btnlg1.click(function() {
      btnlg1.css(btnActive); 
      btnlg2.css(btnInactive); 
    })
    btnlg2.click(function() {
      btnlg2.css(btnActive); 
      btnlg1.css(btnInactive); 
    })
    */
});

if ((typeof myShopify) === 'undefined') {
  myShopify = {};
}

myShopify.addItem = function(id, qty, cb) {
  var query = {
    'type': 'POST',
    'url': '/cart/add.js',
    'data': 'quantity=' + qty + '&id=' + id,
    'dataType': 'json',
    success: function(response){
      cb(response);
    },
    error: function(response){
      response = $.parseJSON(response.responseText);
      cb(response);
    }
  }

  $.ajax(query);
}

myShopify.getCart = function(cb){
  var query = {
    type: 'POST',
    url: '/cart.js',
    dataType: 'json',
    complete: function(response){
      var cart = $.parseJSON(response.responseText);
      if(typeof(cb === "function")){
        cb(cart);
      }
    }
  }
  $.ajax(query);
}

myShopify.switchImage = function(orgImg, src, size) {
  var newSrc = this.getResizedImage(src, size), // the url for the actual image
    newHref = this.getResizedImage(src, "1024x1024"); // the url for the lightbox link

  orgImg.attr("src", newSrc);
  orgImg.parent("a").attr("href", newHref);
}

myShopify.getResizedImage = function(src, size) {
  // find the file extension
  var stringInfo = src.match(/\.([a-z]+)\?/);

  // if there's not a file extension, it's not a valid image url
  if(stringInfo == -1)
    return -1;

  var index = stringInfo.index, // start position of the file extension in the url
      stringStart = src.slice(0, index), // get everything between start and the file extension
      stringEnd = src.slice(index), // get everything from the file extension to end
      newSrc = stringStart + "_" + size + stringEnd; // glue together the new string with a new file size between the start of the string and the extension

  return newSrc;
}

myShopify.preloadImages = function(images, size) {
  // if the argument is a string, make it into a one object array to be able to use the same code below
  if(typeof(images) == "string")
    images = [images];

  // create a DOM object for each image so it preloads, but don't attach it to anything
  for(i = 0; i < images.length; i++) {
    $("<img>", {
      src: images[i]
    });
  }
}